import { useReduxState } from 'hooks';
import { useFormState } from 'informed';
import {
  Checkbox,
  FormGroup,
  FormSection,
  NumberStepper
} from 'components/common/form';

import type { CheckboxProps } from './common/CheckboxInput';

interface Props {
  disabled?: boolean;
  fieldWorkloadEnabled: string;
  fieldWorkloadValue: string;
  isFormSection?: boolean;
  workloadEnabledProps?: CheckboxProps;
  workloadValueProps?: {
    ariaLabel?: string;
    darkMode?: boolean;
    disabled?: boolean;
    inputStyle?: React.CSSProperties;
    label?: string | React.ReactNode;
    max?: number;
    min?: number;
    precision?: number;
    stepValue?: number;
    style?: React.CSSProperties;
  };
}

const WorkloadSettings = ({
  disabled = false,
  fieldWorkloadEnabled,
  fieldWorkloadValue,
  isFormSection = false,
  workloadEnabledProps,
  workloadValueProps
}: Props) => {
  const { messages } = useReduxState();

  const formState = useFormState();

  const Wrapper = isFormSection ? FormSection : FormGroup;

  const wrapperProps = isFormSection
    ? { title: messages.settingsCompletionWorkload }
    : { label: messages.settingsCompletionWorkload };

  return (
    <Wrapper {...wrapperProps}>
      <Checkbox
        disabled={disabled}
        id="workload-is-enabled"
        field={fieldWorkloadEnabled}
        {...workloadEnabledProps}
      />

      <NumberStepper
        disabled={!formState.values?.[fieldWorkloadEnabled]}
        id="workload-value"
        field={fieldWorkloadValue}
        min={0}
        max={100000}
        precision={2}
        stepValue={0.25}
        style={{ marginTop: 10 }}
        {...workloadValueProps}
      />
    </Wrapper>
  );
};

export default WorkloadSettings;
